import { RouteComponentProps } from 'react-router';
import { configService } from '../../services/ConfigService';
import { getConfData } from '../dataApi';
import FavoritesService from '../../services/FavoritesService';
import { getUserData } from '../dataApi';
import { getAppConfig } from '../../config/app.config';

// Interfaz para representar un evento
export interface Evento {
  texto2: string;  // Nombre del evento
  texto3?: string; // Fecha y hora de inicio
  texto4?: string; // Fecha y hora de finalización
  texto6?: string; // Ubicación del evento
  eventCode: string;
}

// Función para hacer login con un evento seleccionado
export const loginWithEvent = async (
  evento: Evento,
  userced: string | undefined,
  setIsLoggedIn: any,
  setUsername: any,
  setUserCed: any,
  setUserID: any,
  setUserOther: any,
  setEventCode: any,
  setEventName: any,
  setEventStartDate: any,
  setEventEndDate: any,
  setEventLocation: any,
  setShowEventsModal: any,
  history: RouteComponentProps['history'],
  setLoading?: (loading: boolean) => void,
  setEventoError?: (error: string) => void,
  loadConfDataAction?: () => void
) => {
  // Depuración: Mostramos el evento recibido en el servicio
  console.log('Evento recibido en loginWithEvent service:', evento);
  if (!userced) return;

  if (setLoading) {
    setLoading(true);
  }

  try {
    // Paso 1: Hacer login con el evento seleccionado (igual que en Mis Eventos)
    console.log('Iniciando login con evento:', evento.eventCode);

    // Usar ConfigService para login con evento específico
    const response = await configService.loginSingleEvent(userced, evento.eventCode);

    if (!response.ok) {
      throw new Error(`Error de red: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    console.log("Login con evento completado:", data);

    if (data.error) {
      if (setEventoError) {
        setEventoError("Error al iniciar sesión con el evento seleccionado: " + data.error);
      }
    } else {
      // Extraemos los datos necesarios
      const username = data.username;
      const ced = data.ced;
      const id = data.id;
      const company = data.company;
      const role = data.role;
      const eventcode = data.eventcode;
      const eventName = data.texto2 || evento.texto2 || '';
      const eventStartDate = data.texto3 || '';
      const eventEndDate = data.texto4 || '';
      const eventLocation = data.texto6 || '';

      // Paso 2: Actualizar el store con los datos básicos (igual que en Mis Eventos)
      console.log('Actualizando store con datos básicos...');
      await setIsLoggedIn(true);
      setUsername(username);
      setUserCed(ced);
      setUserID(id);
      setUserOther(company.concat("&&&", role));
      setEventCode(eventcode);
      setEventName(eventName);
      setEventStartDate(eventStartDate);
      setEventEndDate(eventEndDate);
      setEventLocation(eventLocation);

      // Paso 2.5: Sincronizar favoritos e inicializar FavoritesService
      console.log('events.service: Sincronizando favoritos desde Firebase...');
      try {
        // Llamar directamente a getUserData para sincronizar favoritos
        await getUserData();
        console.log('events.service: Favoritos sincronizados desde Firebase');
      } catch (error) {
        console.warn('events.service: Error al sincronizar favoritos:', error);
      }

      console.log('events.service: Inicializando servicio de favoritos después de sincronización...');
      // Inicializar servicio de favoritos en tiempo real DESPUÉS de la sincronización
      try {
        const favoritesService = FavoritesService.getInstance();
        await favoritesService.initialize(id);
        console.log('events.service: FavoritesService inicializado correctamente');
      } catch (error) {
        console.warn('events.service: Error al inicializar FavoritesService:', error);
      }

      // Paso 3: ✅ CAMBIO: Cargar datos ANTES de redirigir para evitar problemas de timing
      console.log('Cargando datos completos del evento ANTES de redirigir...');
      try {
        // Ahora usamos el servicio para procesar y almacenar los datos
        const DataLoadingService = (await import('../../services/DataLoadingService')).default;
        const dataLoadingService = DataLoadingService.getInstance();

        // Cargamos los datos del evento y esperamos a que termine
        const loadResult = await dataLoadingService.loadEventData(eventcode, true);
        console.log('Resultado de la carga de datos:', loadResult);

        if (!loadResult.success) {
          console.warn('No se pudieron cargar los datos completos del evento:', loadResult.errorMessage);
        } else {
          console.log('Datos del evento cargados exitosamente antes de redirigir');

          // ✅ NUEVO: Actualizar Redux después de cargar los datos
          if (loadConfDataAction) {
            console.log('🔄 events.service: Ejecutando loadConfDataAction...');
            loadConfDataAction();
            console.log('✅ events.service: loadConfDataAction ejecutado');
          }
        }
      } catch (dataError) {
        console.error('Error al cargar los datos completos del evento:', dataError);
      }

      // Paso 4: Cerrar el modal y redirigir (después de cargar los datos)
      console.log('Cerrando modal y redirigiendo...');
      setShowEventsModal(false);
      const defaultRoute = getAppConfig().auth.defaultRoute || '/tabs/schedule';
      history.push(defaultRoute, { direction: 'none' });
    }
  } catch (error) {
    console.error("Error durante el inicio de sesión con evento:", error);
    if (setEventoError) {
      setEventoError("Error de conexión. Por favor, verifique su conexión a internet e intente nuevamente.");
    }
  } finally {
    if (setLoading) {
      setLoading(false);
    }
  }
};
